import { render, staticRenderFns } from "./KontakKami.vue?vue&type=template&id=083f7bd1&scoped=true"
import script from "./KontakKami.vue?vue&type=script&lang=js"
export * from "./KontakKami.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083f7bd1",
  null
  
)

export default component.exports